import { render } from "./IngredientsForm.vue?vue&type=template&id=09a94b83&scoped=true"
import script from "./IngredientsForm.vue?vue&type=script&lang=js"
export * from "./IngredientsForm.vue?vue&type=script&lang=js"

import "./IngredientsForm.vue?vue&type=style&index=0&id=09a94b83&scoped=true&lang=scss"

import exportComponent from "/Users/james/Desktop/VueJS/ingredient-swap/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a94b83"]])

export default __exports__